/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-09 16:42:00
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-16 10:51:50
 */
import React from 'react'
import ContactUS from '../../../components/ContactUS'
import CloseIcon from '../assets/close_icon.png'
import contact_us_icon from '../../../../images/contact_us.png'
import vip_icon from '../assets/vip_icon.png'
import sensors, { sensorsRole } from '../../../../utils/sensors'
import { calcCheckedPhotoNum } from '@/pages/components/photoLib/photo'

const ModalHeader = ({ title, isDisplayHint }) => {
  return (
    <div className="modal-title-with-hint">
      <div className="modal-title-text">{title}</div>
      {isDisplayHint && (
        <div className="modal-title-hint">
          带
          <img
            src={vip_icon}
            alt="vip"
            style={{ width: 16, margin: '0 2px', verticalAlign: 'sub' }}
          />
          标识的功能与高级分类下载为高级会员功能
        </div>
      )}
    </div>
  )
}

const ModalCloseIcon = ({ onClose, myRole, groupId, isVip, photoState }) => {
  return (
    <ContactUS
      fromPage="照片下载"
      track={() => {
        sensors.track('web_click_page_workgroup_pic_download', {
          clickItem: 'contactUs',
          role: sensorsRole(myRole),
          groupID: groupId,
          isVip,
          photoNum: calcCheckedPhotoNum(photoState)
        })
      }}
    >
      <span className="contact-item">
        <img
          style={{ width: '105px', marginRight: '12px' }}
          src={contact_us_icon}
        />
        <img
          width="32"
          height="32"
          src={CloseIcon}
          alt=""
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
        />
      </span>
    </ContactUS>
  )
}

export { ModalHeader, ModalCloseIcon }
